import { LabelsService } from '@services/labels/labels.service';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'icon'
})
export class IconPipe implements PipeTransform {
  constructor(private labelsService: LabelsService) {}

  transform(value: string, fallbackName: string): string {
    const key = `ic.${value}`;

    if (this.labelsService.doesLabelExists(key)) {
      return this.labelsService.getLabel(key);
    } else if (fallbackName) {
      return fallbackName;
    } else {
      return null;
    }
  }
}
